import axios from 'axios';

const axiosInstance = axios.create({
  headers: {
    'X-Tenant-Id': process.env.REACT_APP_TENANT_ID,
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong!')
);

export default axiosInstance;
